import { render, staticRenderFns } from "./AddAlarm.vue?vue&type=template&id=1311f41a&scoped=true"
import script from "./AddAlarm.vue?vue&type=script&lang=ts"
export * from "./AddAlarm.vue?vue&type=script&lang=ts"
import style0 from "./AddAlarm.vue?vue&type=style&index=0&id=1311f41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311f41a",
  null
  
)

export default component.exports